import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Person Minus Outline"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-person-minus-outline',
    templateUrl: './icon-person-minus-outline.component.html',
    styleUrls: ['./icon-person-minus-outline.component.scss'],
    standalone: false
})
export class IconPersonMinusOutlineComponent {

  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
